import { Col, Button } from "react-bootstrap";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { useState, useEffect } from "react";
import axios from "axios";
import useStore from "../../../../Zustand/Zustand";
import "./ButtonSimulator.css";
import ZustandSelectBankType from "../../../../Zustand/ZustandSelectBankType";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ZustandFormImovel from "../../../../Zustand/ZustandFormImovel";
import ZustandProductCgi from "../../../../Zustand/ZustandProductCgi";
import GeneratePDF from "../../../../PDF/GeneratePDF";
import GeneratePDFCgi from "../../../../PDF/GeneratePDFCgi";

const ButtonSimulator = () => {
  const {
    simulacoes,
    setLinkSimulacao,
    isLoadingDowloadSimulation,
    setIsLoadingDowloadSimulation,
    linkSimulacao,
    nomeCompleto,
    emailPrincipal,
    cpf,
    idadeCliente,
    numero,
  } = useStore();
  const [downloadLink, setDownloadLink] = useState(null);
  const { selectInter } = ZustandSelectBankType();
  const { cgi, valorEmprestimo, prazoMesesCgi, valorImovelCgi } =
    ZustandProductCgi();

  const { prazoMeses, valorDoImovel, valorDeEntrada, valorFGTS } =
    ZustandFormImovel();

  const getDownloadLink = async (idSimulacao) => {
    setIsLoadingDowloadSimulation(true);
    const url = `https://api-simulador-financiamento.azurewebsites.net/api/SimuladorFinanciamento/download?idSimulacao=${idSimulacao}`;

    try {
      const response = await axios.get(url);
      const link = response.data;
      setDownloadLink(link);
      setLinkSimulacao(link);
    } catch (error) {
      console.error("Erro ao pegar o link de download:", error);
    } finally {
      setIsLoadingDowloadSimulation(false);
    }
  };

  useEffect(() => {
    if (simulacoes.length > 0 && simulacoes[0].length > 0) {
      const fetchLink = async () => {
        const link = await getDownloadLink(simulacoes[0][0].idSimulacao);
      };

      fetchLink();
    }
  }, [simulacoes]);

  return (
    <div>
      {(() => {
        if (selectInter == "Multibancos" && cgi != "CGI") {
          return (
            <Col className="d-flex flex-column justify-content-center align-items-center mt-4 mb-5">
              <Button
                as="a"
                href={downloadLink}
                download
                target="_blank"
                rel="noopener noreferrer"
                className="simulation-button-simulation"
                disabled={!downloadLink}
              >
                <ArrowDownTrayIcon className="icon" />
                {isLoadingDowloadSimulation
                  ? "Carregando..."
                  : "Baixar simulação completa"}
              </Button>
            </Col>
          );
        } else if (selectInter == "INTER" && cgi != "CGI") {
          return (
            <Col className="d-flex flex-column justify-content-center align-items-center mt-4 mb-5">
              <PDFDownloadLink
                document={
                  <GeneratePDF
                    simulacoes={simulacoes}
                    prazoMeses={prazoMeses}
                    valorDoImovel={valorDoImovel}
                    valorSolicitado={valorDoImovel - valorDeEntrada}
                  />
                }
                fileName="relatorio.pdf"
                style={{
                  textDecoration: "none",
                }}
              >
                {({ isLoadingDowloadSimulation }) => (
                  <Button className="simulation-button-simulation">
                    <ArrowDownTrayIcon className="icon" />
                    {isLoadingDowloadSimulation
                      ? "Carregando..."
                      : "Baixar simulação completa"}
                  </Button>
                )}
              </PDFDownloadLink>
            </Col>
          );
        } else if (cgi == "CGI") {
          return (
            <Col className="d-flex flex-column justify-content-center align-items-center mt-4 mb-5">
              <PDFDownloadLink
                document={
                  <GeneratePDFCgi
                    simulacoes={simulacoes}
                    prazoMeses={prazoMesesCgi}
                    valorDoImovel={valorImovelCgi}
                    valorDeEmprestimo={valorEmprestimo}
                  />
                }
                fileName="relatorio.pdf"
                style={{
                  textDecoration: "none",
                }}
              >
                {({ loading }) => (
                  <Button className="simulation-button-simulation">
                    <ArrowDownTrayIcon className="icon" />
                    {loading ? "Carregando..." : "Baixar simulação completa"}
                  </Button>
                )}
              </PDFDownloadLink>
            </Col>
          );
        }
      })()}
    </div>
  );
};

export default ButtonSimulator;
